import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Titled white card for touch (phone/tablet) forms. Children are laid out in one column on phones
 * and two on tablets; give a child `gridColumn: "1 / -1"` to span the whole row.
 */
const CompactSection = ({ title, action, children, sx }) => (
  <Box component="section" sx={{
    bgcolor: "background.paper", borderRadius: 2, p: 1.5, display: "grid", columnGap: 1.5, rowGap: 2,
    gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))" }, ...sx
  }}>
    <Box sx={{ gridColumn: "1 / -1", display: "flex", alignItems: "center", gap: 1, minHeight: 32, mb: -0.5 }}>
      <Typography sx={{ fontWeight: 700, fontSize: 16, flex: 1 }}>{title}</Typography>
      {action}
    </Box>
    {children}
  </Box>
)

export default CompactSection
